export const baseURL = 'https://api.cloudpayments.com/fundz-ms';
export const oldGloryBaseUrl = 'https://api.cloudpayments.com/oldglory-ms-v2';
export const authURL = 'https://api.cloudpayments.com';
export const apiKey = `5cc31beb901a2e00017617f8b544997b74c44bba8d3465ee3e1f33b4`;
export const tenantName = `OLDGLORY`;
export const QR_BASE_URL = 'https://qr.cloudpayments.com';
export const APP_PROTOCOL = 'oldglorypay-stage';
export const ecommerceBaseUrl = 'https://api.cloudpayments.com/ecommerce-ms';
